<template>
  <component
    :is="vueComponent"
    :component="component"
    :instance="instance"
    v-on="$listeners"
    class="vuevrunplaceholder"
  ></component>
</template>
<script>
import { getVueComponent, hasVueComponent } from "/vodalys/vvuejs";

import { asyncAngularInvoke } from "/vodalys/vvuejs";

import { debug } from "/vodalys/.jslibs";
const log = debug("vue:VrunPlaceholder");
const MissingComponent = () => import("./MissingComponent.vue");
const BadComponent = () => import("./BadComponent.vue");

export default {
  components: {
    MissingComponent,
    BadComponent,
  },
  data() {
    return {
      vueComponent: "",
      instance: undefined,
    };
  },
  props: ["component"],
  // computed: {
  //   async instance() {
  //     let vRunScope = await asyncAngularInvoke((vRunScope) => vRunScope);
  //     let instance = vRunScope.instances[instance_id];
  //     return instance;
  //   },
  // },
  async mounted() {
    if (!this.component) {
      log("no component");
      this.vueComponent = MissingComponent;
      return;
    } else if (this.component?.["#type"] !== "vrun:component") {
      log("bad component");
      this.vueComponent = BadComponent;
      return;
    } else {
      let vRunScope = await asyncAngularInvoke((vRunScope) => vRunScope);
      this.instance = vRunScope.instances[this.component.instance_id];
      this.vueComponent = getVueComponent(this.component.directive);
    }

    if (!this.vueComponent) {
      log(
        "!vueComponent let go vrun-angular-placeholder",
        this.component?.directive
      );
      this.vueComponent = "VrunAngularPlaceholder";
      return;
    }
  },
};
</script> 